import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { postMessage } from "../../services/api";

import LoaderPage from "../../components/CommonComponents/Loader/LoaderPage";
import "../../images/css/contact.css";

interface NewsItem {
  content: string;
}

interface NewsURACPageProps {
  url: string;
  setButton: (value: boolean) => void;
}


const NewsURACPage: React.FC<NewsURACPageProps> = ({ url, setButton }) => {
  const [news, setNews] = useState<NewsItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        const response = await postMessage("/api/news/urac_page", { url }, false);
        setNews(response.data[0] as NewsItem);
      }
      catch (error) {
        toast.error("Failed to load news. Please try again.", { position: "top-right", autoClose: 3000 });
      }
      finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, [url]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        setButton(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setButton]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        {loading ? <LoaderPage /> :
          (<>
            <div className="model-button">
              <button onClick={() => setButton(false)}>X</button>
            </div>
            {loading ? <LoaderPage /> : news ? (
              <div className="model-img" dangerouslySetInnerHTML={{ __html: news?.content }}></div>
            ) : (
              <p className="loader-container-page">Page Not Found</p>
            )}
          </>)}
      </div>
    </div>
  );
};

export default NewsURACPage;